/**
* DevExpress Dashboard (_range-series-properties-composer.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { RangeFilterItem } from '../../../model/items/range-filter/range-filter-item';
import { ChartSeriesPropertiesComposer } from './_chart-series-properties-composer';
export class RangeSeriesPropertiesComposer extends ChartSeriesPropertiesComposer {
    constructor(customizeHandler) {
        super(customizeHandler, RangeFilterItem.rangeSeriesViewTypesMap, false, false);
    }
    _showIgnoreEmptyPointsVisible(model) {
        return false;
    }
    _fillConditionalFormattingTab() { }
}
